module.exports = __webpack_public_path__ + "img/pc-icon-w.f33a12d0.svg";